import React from 'react';
import { motion } from 'framer-motion';

export const Button = ({ children, onClick, variant = 'primary', className = '', ...props }) => {
  const baseStyle = "px-6 py-4 rounded-2xl font-bold transition-all duration-300 flex items-center justify-center gap-2 active:scale-95 text-sm";
  const variants = {
    primary: "bg-slate-900 text-white shadow-xl shadow-slate-200 hover:bg-black",
    secondary: "bg-emerald-500 text-white shadow-lg shadow-emerald-100 hover:bg-emerald-600",
    danger: "bg-rose-50 text-rose-600 border border-rose-100 hover:bg-rose-100",
    ghost: "text-slate-500 hover:text-slate-900 hover:bg-slate-100",
    outline: "border-2 border-slate-100 text-slate-600 hover:border-slate-300 hover:bg-slate-50"
  };

  return (
    <motion.button
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`${baseStyle} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </motion.button>
  );
};